import React, { useContext } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import styles from './style.module.scss';
import { DISPLAY_BUTTON } from '../../../config/constants';
import { AuthContext } from '../../../context/AuthContext';
import SettingSwitch from './SettingSwitch';

const SWITCHABLE_SETTINGS = [
  { key: 'smsInfoSupport', displayText: 'サイトからのお知らせ通知（SMS）' },
  { key: 'mailInfoSupport', displayText: 'サイトからのお知らせ通知（メール）' },
  { key: 'smsChatUser', displayText: 'チャット通知(SMS)' },
  { key: 'mailChatUser', displayText: 'チャット通知(メール)' },
];

function NotificationSetting() {
  const authContext = useContext(AuthContext);
  const userProfile = authContext.userProfile;
  const envUi = authContext.envUi;

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={`通知設定`} hasBackIcon={true} hasHamburger={true} />
        <div className={`${styles.changePhone} align-top`}>
          <form action="/" method="post">
            <div className={styles.back_white_wrap}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="align-center mb-heading">
                  <span className="stick-icon">&nbsp;&nbsp;</span>
                  <span className="title font-4">{'通知設定'}</span>
                </div>
              </div>
              <div style={{ marginTop: '16px', marginRight: '-6px' }}>
                {envUi?.displayAccountNotificationInfo === DISPLAY_BUTTON.SHOW && (
                  <>
                    {SWITCHABLE_SETTINGS.map((s) => {
                      return (
                        <SettingSwitch
                          key={s.key}
                          isOn={Number(userProfile?.notification?.[s.key]) ?? 1}
                          nameField={s.key}
                          text={s.displayText}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default NotificationSetting;
